import { useNavigate, useLocation } from "react-router-dom";

const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToHome = () => {
    //navigate("/home");
    navigate("/home");
  };

  const navigateToForm = () => {
    navigate("/home");
  }

  const navigateToGeneratedPage = (id: string) => {
    navigate(`/${id}`);
  };

  const navigateToResult = (name: string) => {

    navigate(`/result/${name}`);
  }

  const navigateToScreensaver = () => {
    navigate("/");
  };

  const isScreensaverActive = () => {
    return location.pathname === "/"; // Verifica se la route attuale è quella dello screensaver
  };

  return {
    navigateToHome,
    navigateToForm,
    navigateToGeneratedPage,
    navigateToResult,
    navigateToScreensaver,
    isScreensaverActive,
  };
};

export default useNavigation;
